import { render, staticRenderFns } from "./DynamicPropertyType.vue?vue&type=template&id=4e6fbcec&scoped=true&"
import script from "./DynamicPropertyType.vue?vue&type=script&lang=ts&"
export * from "./DynamicPropertyType.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicPropertyType.vue?vue&type=style&index=0&id=4e6fbcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fbcec",
  null
  
)

export default component.exports